import StatsConfig from "./StatsConfig";
import AuthService from "../auth/AuthService"
import moment from "moment"
export default class UserService {
  /******* STATS **********/
  static getStatsByClient(filter, order,app) {  
    console.log("PARAMS getStatsByClient", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByClient;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.state,
          onlyGift:filter.onlyGift
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByClient", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static getStatsByClientDetail(filter, order,app) {  
    console.log("PARAMS getStatsByClientDetail", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByClientDetail;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.state,
          onlyGift:filter.onlyGift,
          tktBuyerDU:filter.tktBuyerDU
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByClient", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
 
  static getStatsByEvent(filter, order,app) {  
    console.log("PARAMS getStatsByEvent", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByEvent;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.state,
          onlyGift:filter.onlyGift
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByEvent", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  
  static getStatsByRRPP(filter, order,app) {  
    console.log("PARAMS getStatsByRRPP", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByRRPP;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.state,
          onlyGift:filter.onlyGift
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByRRPP", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  
  static getStatsByRRPPDetail(filter, order,app) {  
    console.log("PARAMS getStatsByRRPPDetail", filter, order,app)

    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = StatsConfig.endpointStatsByRRPPDetail;
        let body = {
          tktDates:{
            from:filter.from,
            to:filter.to
          },
          period:filter.period,
          place:filter.place,
          state:filter.state,
          onlyGift:filter.onlyGift,
          tktRrpp:filter.tktRrpp
        }
        let response = await StatsConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(body)
        });
        console.log("getStatsByRRPPDetail", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/provider/stats/StatsService.js